import { takeLatest, call, all, put, fork } from 'redux-saga/effects'

import {getUserStats} from "../../api/userApi";
import {getBankStats} from "../../api/bankInfoApi";
import * as actions from "../actions/actions";
import {dashboardFileStats} from "../../api/fileApi";


export default function* IndexSaga() {
    yield all([
        fork(watchFetchUserStatsRequest),
        fork(watchFetchBankStatsRequest),
        fork(watchFetchFileStatsRequest),
    ]);
}


function* watchFetchUserStatsRequest() {
    yield takeLatest(
        actions.FETCH_USER_STATS_REQUEST,
        fetchUserStatsRequest
    )
}

function* fetchUserStatsRequest() {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(getUserStats)
        yield put({ type: actions.FETCH_USER_STATS_SUCCESS, userStats: data })
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_USER_STATS_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })

        }
    }
}

function* watchFetchBankStatsRequest() {
    yield takeLatest(
        actions.FETCH_BANK_STATS_REQUEST,
        fetchBankStatsRequest
    )
}

function* fetchBankStatsRequest() {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(getBankStats)
        yield put({ type: actions.FETCH_BANK_STATS_SUCCESS, bankStats: data })
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.FETCH_BANK_STATS_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }else if(error.request)
        {
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
        }
    }
}

function* watchFetchFileStatsRequest() {
    yield takeLatest(
        actions.FETCH_FILE_STATS_REQUEST,
        fetchFileStatsRequest
    )
}

function* fetchFileStatsRequest() {
    yield put({ type: actions.PROGRESS_START_REQUEST })
    try {
        let { data } = yield call(dashboardFileStats)
        yield put({ type: actions.FETCH_FILE_STATS_SUCCESS, fileStats: data })
        yield put({ type: actions.PROGRESS_STOP_REQUEST })
    } catch (error) {
        if(error.response){
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_FILE_STATS_FAILURE, error: error.response })
            yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
        }else if(error.request)
        {
            yield put({ type: actions.PROGRESS_STOP_REQUEST })
            yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })

        }
    }
}